/**
 * Icon mapping for module manifests.
 * Maps icon string names to actual Ant Design icon components.
 */

import React from "react";
import {
  BankOutlined,
  UserOutlined,
  TrophyOutlined,
  CalendarOutlined,
  FolderOutlined,
  ShoppingCartOutlined,
  ShoppingOutlined,
  AppstoreOutlined,
  FileOutlined,
  DollarOutlined,
  HomeOutlined,
  QuestionOutlined,
  SolutionOutlined,
  AuditOutlined,
  ProjectOutlined,
  CheckSquareOutlined,
  FlagOutlined,
} from "@ant-design/icons";

// Map of icon name strings to React components
const iconMap: Record<string, React.ReactNode> = {
  BankOutlined: <BankOutlined />,
  UserOutlined: <UserOutlined />,
  TrophyOutlined: <TrophyOutlined />,
  CalendarOutlined: <CalendarOutlined />,
  FolderOutlined: <FolderOutlined />,
  ShoppingCartOutlined: <ShoppingCartOutlined />,
  ShoppingOutlined: <ShoppingOutlined />,
  AppstoreOutlined: <AppstoreOutlined />,
  FileOutlined: <FileOutlined />,
  DollarOutlined: <DollarOutlined />,
  HomeOutlined: <HomeOutlined />,
  SolutionOutlined: <SolutionOutlined />,
  AuditOutlined: <AuditOutlined />,
  ProjectOutlined: <ProjectOutlined />,
  CheckSquareOutlined: <CheckSquareOutlined />,
  FlagOutlined: <FlagOutlined />,
};

/**
 * Get a React icon component from an icon name string.
 * Returns a fallback icon if the name is not found.
 */
export function getIconComponent(iconName: string): React.ReactNode {
  return iconMap[iconName] || <QuestionOutlined />;
}

/**
 * Get all available icon names.
 */
export function getAvailableIcons(): string[] {
  return Object.keys(iconMap);
}
